<template>
    <div id="frontmerceddiv">
        <div class="">
            <badgealert/>
        </div>

        <div class="student" v-if="hasBadgePerson">
            <div >
                <div class="images" v-if="hasImagePerson">
                    <div class="imgvert">
                        <!-- <div>
                            <img src="@/assets/dl.jpg" :class="licenseClass" @click="$refs.mymodal.openModal()" >
                        </div>
                        <div>
                            <label class="smalltext logolabel" v-if="BadgeDesign.showLicenseIcon">Driver's License</label>
                        </div> -->
                        
                    </div>

                    <div :class="personImageClass" >
                        <div >
                            <p v-if="showActive && showActiveBlinking" class="activetextclass">Active</p>
                            <p v-if="showInactive && showActiveBlinking" class="inactivetextclass">Inactive</p>
                            <p v-if="showOverrideStatus && showActiveBlinking" class="overridetextclass">{{badgeData.person.statusText_Override}}</p>
                            
                            <img :src="imagePathPerson" class="studentimagemerced activeperson"   v-if="capturedPersonURL==null && showActive && showActiveBlinking" @click="startselfie()" />
                            <img :src="imagePathPerson" class="studentimagemerced inactiveperson"   v-if="capturedPersonURL==null && showInactive && showActiveBlinking" @click="startselfie()" />
                            <img :src="imagePathPerson" class="studentimagemerced overridestatusperson"   v-if="capturedPersonURL==null && showOverrideStatus && showActiveBlinking" @click="startselfie()" />
                            <img :src="imagePathPerson" class="studentimagemerced"   v-if="capturedPersonURL==null && !showActiveBlinking" @click="startselfie()" />
                        </div>
                        
                        <img alt="file"  :src="capturedPersonURL" class="studentimage" v-if="capturedPersonURL!=null" @click="startselfie()" />
                    </div>
                    
                    <div class="imgvert">
                        <!-- <img src="@/assets/vac2.png" :class="vaccineClass" @click="$refs.vaccine.openModal()" >
                        <label class="smalltext logolabel" v-if="BadgeDesign.showVaccineCardIcon">Vaccine</label> -->
                    </div>
                    
                </div>
                <!-- GET PIC  -->
                <smallbutton toplabel="Update Photo" @click="startselfie()" v-if="allowCapturePerson"/>
                <imageall ref="imgselfie" :allowFileSelect="allowFileSelect" :allowFileSelectIfNoCapture='allowFileSelectIfNoCapture' @saveimg="saveimg_selfie"  :showImage='showImagesInCapture' v-if="allowCapturePerson" />


                <div class="vertFlex studentinfo" >

                    <label class="studentnamemerced">{{badgeData.person.firstName}}</label>
                    <label class="studentnamemerced">{{badgeData.person.lastName}}</label>
                    
                
                </div>
                <!-- <div class="vertFlex">
                    <label for="" class="studentclass" v-if="badgeData.person.personRoleName!=null" >{{badgeData.person.personRoleName}}</label>
                    <label for="" class="studentclass" v-if="badgeData.person.programName!=null" >{{badgeData.person.programName}}</label>
                    <label for="" class="studentclass" v-if="badgeData.person.className!=null && showClass" >{{badgeData.person.className}}</label>
                </div>
                 -->
            </div>
        </div>

        <div :class="statusdivClass" v-if="showStatus">
            <label class="statustext">{{badgeData.person.personStatusName}} </label>
        </div>
        <div class="status statusdivnegative" v-if="showInactive && !showActiveBlinking">
            <label class="statustext">INACTIVE</label>
        </div>
        <div class="barcode" v-if="hasBadgePerson && badgeData.person.code!=null  ">
            <div v-if="barcodeType!='QR' && showBarcode">
                <barcode :value="badgeData.person.code" height="50px" :format="barcodeType" textPosition="top"></barcode>
            </div>
            <div v-if="barcodeType=='QR' && showBarcode">
                <qrcode-vue :value="badgeData.person.code" size="80" level="H"/>
            </div>
            <div v-if="!showBarcode">
                <label class="studentnumber">{{badgeData.person.code}} </label>
            </div>
            
        </div>
    </div>
  </template>
  
  <script>
  import smallbutton from '../controls/button.vue'
  import linkbutton from '../controls/linkbutton.vue'
  import {mapFields} from 'vuex-map-fields'
  import badge from '../../services/badge.js'
  import style from '../../style.js'
  import VueBarcode from 'vue-barcode'
  import imageall from '../controls/ImageAll.vue'
  import badgealert from '../badgealert.vue'
  export default {
      components:{
        'barcode':VueBarcode,
          smallbutton,
          linkbutton,
          imageall,
          badgealert
      },
      name:"front_merced",
      mixins:[style, badge],
      props:{
           
      },
      data(){
          return{
              
          }
      },
      computed:{
        ...mapFields([
            'badgeData',
            'imageBasePath',
            'BadgeDesign',
        ]),
      },
      methods:{
        startselfie(){
            this.$refs.imgselfie.openModal()
        },
        startlicenseback(){
            this.$refs.imgback.openModal()
        },
        startlicensefront(){
            this.$refs.imgfront.openModal()
        },
        startvaccine(){
            this.$refs.imgvac.openModal()
        },
      }
  }
  </script>
  
  <style>
.studentimagemerced{
    min-height:270px;
    max-height:270px;
    margin:5px;
    position:relative;
    cursor:pointer;
}
.studentnamemerced{
    font-size:x-large;
    font-weight:bolder;
    margin:0px 5px 0px 0px;
}
.alertmerced{
    padding:10px;
}

.studentnumber{
    margin-top:40px;
    
}
.overridetextclass{
        margin:0px;
        font-weight:bold;
        font-size:larger;
        color:white;
        animation: blink-animation_override 3s  ease-in infinite;
        animation-delay: .5s;
        -webkit-animation: blink-animation_override 3s  ease-in infinite;
    }
    .overridestatusperson{
        border:5px white solid;
        animation: blink-animation_override 3s  ease-in infinite;
        animation-delay: .5s;
        -webkit-animation: blink-animation_override 3s  ease-in infinite;
    }
    @keyframes blink-animation_override {
        to {
            border-color:  #9200FF;
            color:#9200FF;
        }
      }
      @-webkit-keyframes blink-animation_override {
        to {
            border:  #9200FF;
            color:#9200FF;
        }
      }

  </style>



